import React from 'react';
import ReactDOM from "react-dom";
import { AnimatePresence } from "framer-motion";

const CProtal = ({node, children}) => {
    return (
        ReactDOM.createPortal(
            <AnimatePresence>{children}</AnimatePresence>,
            node || document.body,
        )
    )
};

export default CProtal;
